export namespace ReferralActions {
	export class GetReferral {
		static readonly type = '[My Jobs] Get Referral';
		constructor(public payload: any) {}
	}
}
